import { SoundEffect } from "@hg/media"

export const sfx = new SoundEffect({
    effectsDict: {
        CHESS: require("./game/chess.mp3"),
        GAME_END: require("./game/gameEnd.mp3"),
        SKILL1_1: require("./game/skill1_1.mp3"),
        SKILL1_2: require("./game/skill1_2.mp3"),
        SKILL2_1: require("./game/skill2_1.mp3"),
        SKILL2_2: require("./game/skill2_2.mp3"),
        SKILL3_1: require("./game/skill3_1.mp3"),
        SKILL3_2: require("./game/skill3_2.mp3"),
        SKILL4_1: require("./game/skill4_1.mp3"),
        SKILL4_2: require("./game/skill4_2.mp3"),
        SKILL5_1: require("./game/skill5_1.mp3"),
        SKILL5_2: require("./game/skill5_2.mp3"),
        apply_click: require("./apply_click.mp3"),
        back_click: require("./back_click.mp3"),
        click: require("./click.mp3"),
        dialog: require("./dialog.mp3"),
    },
})

export const sfxPlay: typeof sfx.play = (...args) => {
    try {
        sfx.play(...args)
    } catch (error) {}
}
